import React, { useState } from "react";
import { CONFIRM_WORD } from "./constants";

/**
 * MergeConfirm — step 3. Mirrors ProfileTypeConversionModal's type-the-word
 * confirmation gate: the destructive Execute button unlocks only when the
 * operator types the confirm word exactly. Restates WHAT is being confirmed —
 * source → destination, by name — so the operator gets one last identity check
 * on the same screen that asks them to type the word.
 */
function MergeConfirm({ source, destination, executing, onBack, onExecute }) {
  const [confirmText, setConfirmText] = useState("");
  const canExecute = confirmText === CONFIRM_WORD && !executing;

  const sideName = (side) => side?.name || (side?.id != null ? `#${side.id}` : "?");

  // Same affordance as the preview cards: command-clickable identity check.
  const linkedName = (side) =>
    side?.href ? (
      <a href={side.href} target="_blank" rel="noopener noreferrer">
        {sideName(side)}
      </a>
    ) : (
      sideName(side)
    );

  return (
    <div>
      <div className="d-flex justify-content-center align-items-center gap-3 mb-3" data-testid="confirm-recap">
        <div className="text-center">
          <div className="fs-5 fw-bold">
            {linkedName(source)}
            {source?.id != null && <span className="text-muted fw-normal"> (#{source.id})</span>}
          </div>
          <div className="small text-danger">removed</div>
        </div>
        <i className="fa fa-arrow-right fs-4 text-muted" aria-label="merged into" />
        <div className="text-center">
          <div className="fs-5 fw-bold">
            {linkedName(destination)}
            {destination?.id != null && <span className="text-muted fw-normal"> (#{destination.id})</span>}
          </div>
          <div className="small text-success">kept</div>
        </div>
      </div>

      <div className="alert alert-danger">
        <i className="fa fa-exclamation-triangle me-2" />
        <strong>This action is irreversible.</strong> The source entity will be permanently deleted and its associations
        reassigned to the destination.
      </div>

      <div className="mb-3 text-center">
        <label className="form-label fs-5" htmlFor="confirm-merge-input">
          Type <strong>{CONFIRM_WORD}</strong> to confirm:
        </label>
        <input
          id="confirm-merge-input"
          type="text"
          className="form-control mx-auto"
          style={{ maxWidth: "16rem" }}
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder={CONFIRM_WORD}
          disabled={executing}
          autoComplete="off"
        />
      </div>

      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-secondary" onClick={onBack} disabled={executing}>
          Back
        </button>
        <button type="button" className="btn btn-danger" onClick={onExecute} disabled={!canExecute}>
          {executing ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" />
              Merging…
            </>
          ) : (
            "Execute Merge"
          )}
        </button>
      </div>
    </div>
  );
}

export default MergeConfirm;
